import { apiRequest } from './api';
import type { ArtistListItem } from './artistsApi';
import type { AuthUser } from '../context/AuthContext';

export interface ArtistsOverviewResponse {
  user: AuthUser | null;
  likes: {
    artists: number[];
    tracks: number[];
  };
  artists: ArtistListItem[];
  featured_artists: ArtistListItem[];
  lanes: string[];
}

export function fetchArtistsOverview(authToken?: string) {
  return apiRequest<ArtistsOverviewResponse>('/artists/overview', authToken ? { authToken } : undefined);
}
